import React, { useState, useRef } from 'react';
import Navigation from '../components/Navigation';
import './FilmMusic.css';

const FilmMusic = () => {
  const [currentTrack, setCurrentTrack] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  // Film music tracks from the screenshot
  const tracks = [
    { id: 1, title: "Timeless", artist: "Tahir Palali", duration: "1:34", file: null },
    { id: 2, title: "Final Battle, Orchestral", artist: "Tahir Palali", duration: "1:57", file: null },
    { id: 3, title: "Departed (preview)", artist: "Tahir Palali", duration: "0:45", file: null },
    { id: 4, title: "Autumn (preview)", artist: "Tahir Palali", duration: "0:46", file: null },
  ];

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleTrackClick = (index) => {
    setCurrentTrack(index);
    setIsPlaying(false);
  };

  return (
    <div className="film-music-page">
      <Navigation />
      
      <div className="film-music-content">
        <h1 className="album-title">TAHIR PALALI - O</h1>
        
        <div className="album-player">
          <div className="album-artwork-section">
            <div className="album-artwork">
              <img 
                src={require('../assets/images/Eyvind+Earle+Tutt\'Art@+(36).jpg')} 
                alt="Film Music Artwork" 
                className="artwork-image"
              />
              <div className="player-controls">
                <button 
                  className={`play-pause-btn ${isPlaying ? 'playing' : 'paused'}`}
                  onClick={handlePlayPause}
                >
                </button>
              </div>
            </div>
          </div>
          
          <div className="track-list-section">
            <div className="track-list">
              {tracks.map((track, index) => (
                <div 
                  key={track.id}
                  className={`track-item ${index === currentTrack ? 'active' : ''}`}
                  onClick={() => handleTrackClick(index)}
                >
                  <div className="track-info">
                    <div className="track-title">{track.title}</div>
                    <div className="track-artist">{track.artist}</div>
                  </div>
                  <div className="track-duration">{track.duration}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="music-instructions">
          <p>Film Music compositions by Tahir Palali</p>
        </div>
      </div>
      
      <audio 
        ref={audioRef}
        src={tracks[currentTrack]?.file}
        onEnded={() => setIsPlaying(false)}
      />
    </div>
  );
};

export default FilmMusic;